<template>
  <div class="faq App-faq-detail bg-white position-relative">
    <div class="text-center loading_icon" v-show="questionAnswerLoading">
      <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
    <div class="inner" v-show="!questionAnswerLoading">
      <h1 class="h1 title">Q. {{ qaList.title ? qaList.title.rendered : "" }}</h1>
      <div class="content">
        <div class="answer" v-html=" qaList.content ? qaList.content.rendered : '' "></div>
        <div class="text white-space-pre-wrap" v-html="qaList.description ? qaList.description : '' "></div>
        <div class="btn-wrapper">
          <button class="btn btn-black text-white d-block position-relative" @click="goback" type="submit">{{$t('btn.back')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { VueLoading } from 'vue-loading-template'
  import { META_FAQ } from '../../mixins/metadata.js'

  export default {
    mixins: [META_FAQ],
    name: 'FaqPage',
    components: {
      VueLoading,
    },
    data() {
      return {
        qaList: [],
      }
    },
    computed: {
      ...mapState('faq', ['questionAnswerLoading', 'questionAnswers', 'currentId']),
      ...mapGetters('faq', ['questionAnswers3']),
    },
    watch: {
      questionAnswers(data) {
        const questionAnswers = _.cloneDeep(data)
        const map = _.map(questionAnswers)
        const flatten = _.flattenDeep(map)
        const num = (this.$route.params.id) * 1
        const find = _.find(flatten, { id: num })
        this.$set(this, 'qaList', find)
      },
    },
    methods: {
      ...mapActions('faq', ['getQuestionAnswers', 'setCurrentId']),
      goback() {
        this.$router.go(-1)
      }
    },
    created() {
      this.setCurrentId(this.$route.params.id)
      // if (this.questionAnswers.length === 0) {
        this.getQuestionAnswers()
      // }
    },
    mounted() {
    }
  }
</script>
<style lang="scss" scoped>
.loading_icon{
  //
  width: 100%;
  position: absolute;
  top:80px;

}
</style>
